var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.363 3.53846C9.60295 3.53846 8.17616 4.96525 8.17616 6.72528C8.17616 8.4853 9.60295 9.91209 11.363 9.91209C13.123 9.91209 14.5497 8.4853 14.5497 6.72528C14.5497 4.96525 13.123 3.53846 11.363 3.53846ZM6.6377 6.72528C6.6377 4.11558 8.75328 2 11.363 2C13.9726 2 16.0882 4.11558 16.0882 6.72528C16.0882 9.33497 13.9726 11.4506 11.363 11.4506C8.75328 11.4506 6.6377 9.33497 6.6377 6.72528Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41153 15.4067C7.27249 15.4067 5.53846 17.1407 5.53846 19.2798C5.53846 19.3862 5.55682 19.4597 5.57526 19.5014C5.59011 19.5349 5.60106 19.5413 5.60591 19.5441C6.13353 19.8542 7.65133 20.4616 11.3626 20.4616C15.0739 20.4616 16.5913 19.8544 17.1189 19.5444C17.1238 19.5415 17.1352 19.5349 17.15 19.5014C17.1685 19.4597 17.1868 19.3862 17.1868 19.2798C17.1868 17.1407 15.4528 15.4067 13.3137 15.4067H9.41153ZM4 19.2798C4 16.2911 6.42282 13.8682 9.41153 13.8682H13.3137C16.3024 13.8682 18.7253 16.2911 18.7253 19.2798C18.7253 19.7945 18.5513 20.487 17.8984 20.8707C17.0381 21.3764 15.2089 22.0001 11.3626 22.0001C7.51639 22.0001 5.68722 21.3764 4.82683 20.8707C4.17398 20.487 4 19.7945 4 19.2798Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileWhite);
export default __webpack_public_path__ + "static/media/profile_white.dc5fd9a1bcfcb40e90963954dcc5bf76.svg";
export { ForwardRef as ReactComponent };